import Vue from 'vue';


const commentNickname = function (nickname) {
  if (nickname.length >= 4) {
    return nickname.substr(0, 1) + '**' + nickname.substr(nickname.length - 1, 1)
  } else {
    return nickname.substr(0, 1) + '**'
  }
};

Vue.filter('commentNickname', commentNickname);



// WEBPACK FOOTER //
// ./src/filters/commentNickname.js